<template>
    <div class="wizard-steps content-wrapper">
        <!-- <div class="d-flex btn-group w-full gap-0 p-0 m-0">
            <button v-for="(item, index) in items" :key="index"
                class="flex-grow-1 flex-fill text-center btn shadow-none rounded-0" :class="{
                    'btn-primary': currentItem.component === item.component,
                    'btn-light': currentItem.component !== item.component
                }" @click="currentItem.component = item.component">
                {{ item.name }}
            </button>
        </div> -->
        <ul class="nav nav-pills mb-4" id="pills-tab">
            <li class="nav-item" v-for="(item, index) in items" :key="'nav-link' + index">
                <a class="nav-link" :class="{ active: index === currentTabIndex }" :id="'pills-' + item.name + '-tab'"
                    data-toggle="pill" :href="'#' + item.name + '-' + index" @click="selectedTab(index)">
                    <div class="text-capitalize" :class="[index === 0 ? 'tab-step-init' : 'tab-step']">
                        {{ item.name }}
                    </div>
                </a>
            </li>
        </ul>
        <keep-alive>
            <component :is="currentItem.component" v-bind="currentItem.props" :key="currentItem.props.name"></component>
        </keep-alive>
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
    extends: CoreLibrary,
    name: "Voucher",
    data() {
        return {
            currentTabIndex: 0,
            currentItem: {
                name: this.$t('tab_voucher_request'),
                component: 'voucher-request',
                props: {
                    title: this.$t('title_voucher_request'),
                    useAddButton: true,
                    useApprovalButton: false,
                },
            },
            items: [
                {
                    name: this.$t('tab_voucher_request'),
                    component: 'voucher-request',
                    props: {
                        title: this.$t('title_voucher_request'),
                        useAddButton: true,
                        useApprovalButton: false,
                        useVoucherNeedClaim: false,
                        useVoucherNeedSendGift: false,
                    },
                },
                {
                    name: this.$t('tab_voucher_approval'),
                    component: 'voucher-request',
                    props: {
                        title: this.$t('title_voucher_approval'),
                        useAddButton: false,
                        useApprovalButton: true,
                        useVoucherNeedClaim: false,
                        useVoucherNeedSendGift: false,
                        queryString: "approval_status=PENDING&exclude_expired=true",
                    },
                },
                {
                    name: this.$t('tab_voucher_gift'),
                    component: 'voucher-request',
                    props: {
                        title: this.$t('title_voucher_gift'),
                        useAddButton: false,
                        useApprovalButton: false,
                        useVoucherNeedClaim: false,
                        useVoucherNeedSendGift: true,
                        queryString: "approval_status=APPROVED&voucher_type=GIFT&without_referrer=true",
                    },
                },
                {
                    name: this.$t('tab_voucher_claim'),
                    component: 'voucher-request',
                    props: {
                        title: this.$t('title_voucher_claim'),
                        useAddButton: false,
                        useApprovalButton: false,
                        useVoucherNeedClaim: true,
                        useVoucherNeedSendGift: false,
                        queryString: "claimable=true&exclude_expired=true",
                    },
                },
                {
                    name: this.$t('tab_voucher_reward'),
                    component: 'voucher-request',
                    props: {
                        title: this.$t('title_voucher_reward'),
                        useAddButton: false,
                        useApprovalButton: false,
                        useVoucherNeedClaim: false,
                        useVoucherNeedSendGift: false,
                        queryString: "approval_status=APPROVED&voucher_type=REWARD",
                    },
                },
            ],
        };
    },
    methods: {
        selectedTab(value) {
            this.currentTabIndex = value;
            this.currentItem = this.items[value];
            this.currentComponentName();
        },
        currentComponentName() {
            this.$emit(
                "selectedComponentName",
                this.currentItem.component
            );
        },
    },
}
</script>